import zoneIcon from './svg/zoneIcon.svg?url';

export const ZoneIcon = () => {
	return <img src={zoneIcon} alt="Zone Icon" />;
};
